import { useQueryClient } from "react-query";
import React, { useEffect, useState } from "react";
import Image from "../../../components/atom/image";
import renderHTML from 'react-render-html';
import { Link, withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { checkHUFUser, getDecryptedItem, isAdminUser, isValidUrl } from "../../../helper/methods";
import { NFO_DATA, userTypeList } from "../../../helper/constant";
import useDeviceType from "../../../hooks/useDeviceType";
import { createLog } from "../../../helper/logger";
import { useHistory } from "react-router-dom";
import { useSafeWindow } from "../../../hooks/useSafe";
import { useFolioDet } from "../../../components/pages/SipHouse/sipDetails/api";

const Sidebar = (props) => {
  const safeWindow = useSafeWindow()
  const history = useHistory();  // moved useHistory here
  const { isCustomDevice: hamBurgerVisible } = useDeviceType({ minWidth: 0, maxWidth: 991 });
  console.log(hamBurgerVisible, "hamBurgerVisible");

  const [open, setOpen] = useState('');
  let getBanner = useSelector(state => state.trans.Banner);

  console.log(getBanner, 'getBanner=')
  console.log(props, 'privateRoutre', props.location.pathname)
  let getpathName = props.location.pathname;
  const isPathActive = (getpathName) => {
    console.log(getpathName, 'isPathActivePATH')
    return props.location.pathname.startsWith(getpathName);
  }
  console.log(isPathActive(getpathName), 'isPathActive')
  const menuHandler = (data, boolVal, currentItem) => {
    const linkto = currentItem?.menu?.linkTo;
    if (linkto === "/sip/select-fund") {
      createLog("MF_Invest_SIP");
    }
    if (open === data) {
      setOpen('')
    } else {
      setOpen(data)
    }

    console.log(boolVal);
    if (boolVal === 0) {
      if (hamBurgerVisible) {
        document.querySelector('.sidebar-offcanvas').classList.remove('active');
        document.body.classList.add('sidebar-icon-only');
      }
    }
    if (document.body.classList.contains('sidebar-icon-only')) {
      props.handleburgermenu(false)
    }
    else {
      props.handleburgermenu(true)
    }

    if (currentItem && isValidUrl(currentItem.menu.linkTo)) {
      safeWindow?.open(currentItem.menu.linkTo, '_self')
    }

  }

  // added by Nikesh
  const menuHandlertwist = () => {
    if (hamBurgerVisible) {
      document.body.classList.add('sidebar-icon-only');
      document.querySelector('.sidebar-offcanvas').classList.remove('active');
    }
    addBurgerClass()
  }

  const investNowClick = () => {
    let queryParams = safeWindow?.location?.search;
    let existingQueryParams = "";
    if (queryParams) {
      let firstQuesMarkIndex = queryParams?.indexOf("?");
      if (firstQuesMarkIndex > -1) {
        existingQueryParams =
          queryParams?.substring(firstQuesMarkIndex + 1) || "";
        existingQueryParams = "&" + existingQueryParams;
      }
    }
    let amcPlanCode = "GD";
    let sOptCode = "G";

    let planCode = "D"; // D or R
    let schemeCode = NFO_DATA?.NFO_SCHEME_CODE;

    let landingPage = true;

    let redirUrl = `/quickbuy?fund=${schemeCode}&plan=${planCode}&amcPlan=${amcPlanCode}&option=${sOptCode}${existingQueryParams}&landingPage=${landingPage}`;
    if(safeWindow) history.push(redirUrl);
  }

  const investNowClickForBasket = () => {
    const redirUrl = `/quickbuy?basket=true`
    if(safeWindow) history.push(redirUrl);
  }

  const addBurgerClass = () => {
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item .nav-link .menu-title').forEach((el) => {
      if (body.classList.contains('sidebar-icon-only')) {
        //  el.classList.remove('new_menuBurger');
        props.handleburgermenu(false)

      } else {
        el.classList.add('new_menuBurger');
      }
    });
  }

  useEffect(() => {
    const tmpHideSidebar = ["/fab-plan/investment-calculator"]
    console.log("window.location.pathname", safeWindow?.location.pathname);
    if (tmpHideSidebar.includes(safeWindow?.location?.pathname)) {
      document.body.classList.toggle('sidebar-icon-only')
      if (!document.body.classList.contains('sidebar-icon-only')) {
        document.body.classList.toggle('sidebar-icon-only')
      }
    }
  }, [safeWindow?.location?.pathname])


  useEffect(() => {
    const body = document.querySelector('body');

    const mouseOverListener = (el) => {
      if (body.classList.contains('sidebar-icon-only')) {
        el.classList.add('hover-open');
      }
    }
    const mouseOutListener = (el) => {
      if (body.classList.contains('sidebar-icon-only')) {
        el.classList.remove('hover-open');
      }
    }
    document.querySelectorAll('.sidebar .nav-item')?.forEach?.((el) => {
      el.addEventListener('mouseover', () => mouseOverListener(el));
      el.addEventListener('mouseout', () => mouseOutListener(el));
    });

    return (() => {
      document.querySelectorAll('.sidebar .nav-item')?.forEach?.((el) => {
        el.removeEventListener('mouseover', () => mouseOverListener(el));
        el.removeEventListener('mouseout', () => mouseOutListener(el));
      });
    })
  }, [])
  let display = "";

  let isNRO = false;
  let utype = localStorage.getItem("userType");
  const queryClient = useQueryClient();
  const { data: folioData, isLoading: isFolioDataLoading } = useFolioDet();
  // if (utype) {
  if (utype && userTypeList.indexOf(utype?.toUpperCase()) > -1) {
    // if (utype.toUpperCase() === "RESIDENT INDIAN" || utype.toUpperCase() === "NRI-REPATRIABLE" || utype.toUpperCase() === "NRI-NON-REPATRIABLE") {
    isNRO = true
  }
  // }

  let menuArray = props.option;
  const hufUser = checkHUFUser()
  if (hufUser) {
    menuArray.forEach((menuItem, index) => {
      if (menuItem.menu.label === "Manage Account" && menuItem.subMenu) {
        menuItem.subMenu = menuItem.subMenu.filter(subMenuItem => (subMenuItem.menu.label !== "Add E-Mandate" && subMenuItem.menu.label !== "UPI Mandate"));
        if (menuItem.subMenu.length === 0) {
          delete menuItem.subMenu;
        }
      }
    });
  }

  useEffect(() => {
    // Force a refetch of the foliodet query when the sidebar mounts if folioData is empty. When login with /redirectUrl=somePath, we performs a full page navigation using window.location.href. This breaks React Query's context and your query doesn't initialize properly added refetch for that case
    if (folioData === undefined || folioData?.length === 0) {
      queryClient.refetchQueries(['foliodet']);
    }
  }, []);

  if (!isFolioDataLoading && folioData !== undefined && folioData?.length === 0) {
    menuArray = menuArray.filter(menuItem => {
      // Keep only "My Portfolio" and the menu containing "Create Folio"
      return (
        menuItem.menu.label === "My Portfolio" ||
        (menuItem.subMenu &&
          menuItem.subMenu.some(subItem => subItem.menu.label === "Create Folio"))
      );
    });

    // If a menu with submenu is kept, filter its submenu to only show "Create Folio"
    menuArray.forEach(menuItem => {
      if (menuItem.subMenu) {
        menuItem.subMenu = menuItem.subMenu.filter(subItem =>
          subItem.menu.label === "Create Folio"
        );
      }
    });
  }

  let getOption = menuArray;

  console.log("checking at line 97: ", getOption, menuArray);

  getOption.sort(function (a, b) {
    return a.menu.mainMenuId - b.menu.mainMenuId;
  })

  if (props.newClient) {
    getOption = getOption.filter(el => el.menu.label != "Orderbook");
    console.log("new Array of options", getOption)
  }
  let flagShowNav = true;
  let isIndividualPan = true;
  if (Object.keys(getBanner).length > 0) {
    //exampleObj.hasOwnProperty("height");
    if (getBanner.hasOwnProperty("IsNFO")) {
      flagShowNav = getBanner.IsNFO
    }
  }

  const userInfo = getDecryptedItem("userInfo");

  console.log('isIndividualPan:', isIndividualPan);

  return (
    <React.Fragment>
      <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
          {/* change below flag to true when NFO is Live */}
          {isAdminUser() || NFO_DATA.NFO_IS_ACTIVE ? //userInfo?.isIndividualPan && flagShowNav ?
            // <li className="nav-item"><Link to="/transact/quick-invest?key=nfo" className="nav-link">
            //   <span className="icon-bg">
            //     <i className={"invest_navicon"}></i>
            //   </span>NFO</Link></li>
            <li className="nav-item">
              <button className="nav-link" style={{ width: '100%' }} onClick={investNowClick}>
                <span className="icon-bg">
                  <i className={"invest_navicon"}></i>
                </span>
                NFO
              </button>
            </li>
            : null
          }
          {/* this code for add static menu when any new scheme launch
           <li class="nav-item">
            <a
              href={process.env.REACT_APP_NFO}
              class="nav-link"
            //target="_blank"
            >
              <span className="icon-bg">
                <i className={"invest_navicon"}></i>
              </span>
              <span className={props.burgerMenu ? `menu-title new_menuBurger` : 'menu-title'}>{process.env.REACT_APP_NFO_MENU_NAME}
                <b className="burgerNew">NEW</b>
              </span>
            </a>
          </li> */}
          {getOption.map((curr, index) => {
            let { menu, subMenu } = curr;
            let active = false;
            let innerActive = false;
            active = isPathActive(curr.menu.linkTo);

            let innermenu = "";
            let SubmenuLink = "";
            let innermenuCall = 0;
            if (subMenu) {
              innermenuCall = 1;
              subMenu.sort(function (a, b) {
                return a.menu.submenuOrder - b.menu.submenuOrder;
              });


              innermenu = subMenu.map((Cursub, index1) => {
                console.log(innermenu)
                console.log(Cursub.menu.linkTo, 'Cursub', getpathName)
                innerActive = getpathName === Cursub.menu.linkTo;
                if (getpathName === Cursub.menu.linkTo) {
                  SubmenuLink = Cursub.menu.linkTo;
                }
                return (
                  <li class="nav-item">

                <Link class={`nav-link ${getpathName === Cursub.menu.linkTo ? "active" : ""}`} to={Cursub.menu.linkTo} onClick={() => menuHandlertwist()}>
                      {Cursub.menu.label}
                            {Cursub?.menu?.label==="UPI Mandate" && 
                            <span className="new_menuBurger"><b className="burgerNew">NEW</b> </span>}
                           
                      <>
                        {' '}
                        {Cursub.menu.label == "Loan Against MF" ?
                          <>
                            <span className="help-tip fifteentxt">

                              <Image image="category/info-icon.svg" class="info-icon" />
                              <div className="infoHoverText">
                                No selling of Mutual funds.<br />Leverage your investments in mutual funds for loans to meet your expenses.
                              </div>
                            </span>
                            <span className="new_menuBurger">
                              <b className="burgerNew">NEW</b>
                            </span>
                          </>
                          : null}
                      </>
                    </Link>

                  </li>
                )
                //SA Commented my code because of DXTECH issue-->
                //SA Changes done for the URLs that has to be open in new tab or the same tab-- Abhishek
                // if (Cursub.menu.subexternalURL === 1) {
                //   if (Cursub.menu.subnewTab === 1) {
                //     return (
                //       <li class="nav-item">
                //         <a href={Cursub.menu.linkTo} class={`nav-link ${getpathName === Cursub.menu.linkTo ? "active" : ""}`} target="_blank" onClick={() => menuHandlertwist()}>
                //           {Cursub.menu.label}
                //         </a>
                //       </li>
                //     )
                //   } else {
                //     return (
                //       <li class="nav-item">
                //         <a href={Cursub.menu.linkTo} class={`nav-link ${getpathName === Cursub.menu.linkTo ? "active" : ""}`} target="_self" onClick={() => menuHandlertwist()}>
                //           {Cursub.menu.label}
                //         </a>
                //       </li>
                //     )
                //   }
                // } else {
                //   if (Cursub.menu.subnewTab === 1) {
                //     return (
                //       <li class="nav-item">
                //         <a href={Cursub.menu.linkTo} class={`nav-link ${getpathName === Cursub.menu.linkTo ? "active" : ""}`} target="_blank" onClick={() => menuHandlertwist()}>
                //           {Cursub.menu.label}
                //         </a>
                //       </li>
                //     )
                //   } else {
                //     return (
                //       <li class="nav-item">
                //         <Link class={`nav-link ${getpathName === Cursub.menu.linkTo ? "active" : ""}`} to={Cursub.menu.linkTo} onClick={() => menuHandlertwist()}>
                //           {Cursub.menu.label}
                //         </Link>
                //       </li>
                //     )
                //   }
                // }
                //EA Changes done for the URLs that has to be open in new tab or the same tab-- Abhishek                                                                                                                             
              })
            }
            console.log(innerActive, 'SideBarinnerActive,', SubmenuLink, '==', getpathName, open)
            //SA Changes done for the URLs that has to be open in new tab or the same tab-- Abhishek 
            // if (curr.menu.externalURL === 1) {
            //   if (curr.menu.newTab === 1) {
            //     return (
            //       <li class="nav-item">
            //         <a href={curr.menu.linkTo} class="nav-link" target="_blank">
            //           <span className="icon-bg">
            //             <i className={curr.menu.class}></i>
            //           </span>
            //           <span className={(props.burgerMenu) ? `menu-title new_menuBurger` : 'menu-title'}>{curr.menu.label}
            //             {curr.menu.newMenu == 1 &&
            //               <b className="burgerNew">NEW</b>}
            //           </span>

            //         </a>
            //       </li>
            //     )
            //   } else {
            //     return (
            //       <li class="nav-item">
            //         <a href={curr.menu.linkTo} class="nav-link" target="_self">
            //           <span className="icon-bg">
            //             <i className={curr.menu.class}></i>
            //           </span>
            //           <span className={(props.burgerMenu) ? `menu-title new_menuBurger` : 'menu-title'}>{curr.menu.label}
            //             {curr.menu.newMenu == 1 &&
            //               <b className="burgerNew">NEW</b>}
            //           </span>

            //         </a>
            //       </li>
            // <li className={`nav-item ${getpathName === curr.menu.linkTo || SubmenuLink === getpathName ? "active " : ""} ${open === 'menu' + index ? "open" : ""}`}>
            //   <Link to={innermenu == "" ? curr.menu.linkTo : "#"}
            //     className={`nav-link ${innermenu !== "" ? "dropsubmenu" : null}`}
            //     onClick={() => menuHandler(`menu${index}`, innermenuCall)}>
            //     <span className="icon-bg">
            //       {/* <i className="mdi mdi-crosshairs-gps menu-icon"></i> */}
            //       <i className={curr.menu.class}></i>
            //     </span>
            //     <span className={(props.burgerMenu) ? `menu-title new_menuBurger` : 'menu-title'}>{curr.menu.label}
            //       {curr.menu.newMenu == 1 &&
            //         <b className="burgerNew">NEW</b>}
            //     </span>
            //     {innermenu !== "" ? <i class="menu-arrow"></i> : null}
            //   </Link>
            //   {innermenu !== "" ?
            //     <div className={`collapse ${open === 'menu' + index ? 'show' : null}`} >
            //       <ul className="nav flex-column sub-menu">{innermenu}</ul>
            //     </div>
            //     : null}
            // </li>
            //     )
            //   }
            // } else {
            //   if (curr.menu.newTab === 1) {
            //     return (
            //       <li class="nav-item">
            //         <a href={curr.menu.linkTo} class="nav-link" target="_blank">
            //           <span className="icon-bg">
            //             <i className={curr.menu.class}></i>
            //           </span>
            //           <span className={(props.burgerMenu) ? `menu-title new_menuBurger` : 'menu-title'}>{curr.menu.label}
            //             {curr.menu.newMenu == 1 &&
            //               <b className="burgerNew">NEW</b>}
            //           </span>

            //         </a>
            //       </li>
            //     )
            //   } else {
            //     return (
            //       <li className={`nav-item ${getpathName === curr.menu.linkTo || SubmenuLink === getpathName ? "active " : ""} ${open === 'menu' + index ? "open" : ""}`}>
            //         <Link to={innermenu == "" ? curr.menu.linkTo : "#"}
            //           className={`nav-link ${innermenu !== "" ? "dropsubmenu" : null}`}
            //           onClick={() => menuHandler(`menu${index}`, innermenuCall)}>
            //           <span className="icon-bg">
            //             {/* <i className="mdi mdi-crosshairs-gps menu-icon"></i> */}
            //             <i className={curr.menu.class}></i>
            //           </span>
            //           <span className={(props.burgerMenu) ? `menu-title new_menuBurger` : 'menu-title'}>{curr.menu.label}
            //             {curr.menu.newMenu == 1 &&
            //               <b className="burgerNew">NEW</b>}
            //           </span>
            //           {innermenu !== "" ? <i class="menu-arrow"></i> : null}
            //         </Link>
            //         {innermenu !== "" ?
            //           <div className={`collapse ${open === 'menu' + index ? 'show' : null}`} >
            //             <ul className="nav flex-column sub-menu">{innermenu}</ul>
            //           </div>
            //           : null}
            //       </li>
            //     )
            //   }
            // }
            //EA Changes done for the URLs that has to be open in new tab or the same tab-- Abhishek 
            //EA Commented my code because of DXTECH issue-->

            return (
              <li className={`nav-item ${getpathName === curr.menu.linkTo || SubmenuLink === getpathName ? "active " : ""} ${open === 'menu' + index ? "open" : ""}`}>
                <Link to={innermenu == "" && !isValidUrl(curr.menu.linkTo) ? curr.menu.linkTo : "#"}
                  className={`nav-link ${innermenu !== "" ? "dropsubmenu" : null}`}
                  onClick={() => menuHandler(`menu${index}`, innermenuCall, curr)}>
                  <span className="icon-bg">
                    {/* <i className="mdi mdi-crosshairs-gps menu-icon"></i> */}
                    <i className={curr.menu.class}></i>
                  </span>
                  <span className={`menu-title ${curr.menu.label === 'Start SIP' ? 'start-sip' : ''}`}>{curr.menu.label}</span>
                  {innermenu !== "" ? <i class="menu-arrow"></i> : null}
                </Link>
                {innermenu !== "" ?
                  <div className={`collapse ${open === 'menu' + index ? 'show' : null}`} >
                    <ul className="nav flex-column sub-menu mb-4">{innermenu}</ul>
                  </div>
                  : null}
              </li>
            )
          })
          }

        </ul>
      </nav>
    </React.Fragment>
  );

};

export default withRouter(Sidebar);